module.exports = __webpack_public_path__ + "static/media/ex-adomin-dashboard-icon1.63c013cc.svg";